import { createSlice } from '@reduxjs/toolkit';
import { difference, union } from 'es-toolkit';

import { fetchStorefrontItems } from '@/redux/modules/storefront/storefront.actions';
import { defaultStorefrontSlice } from '@/redux/modules/storefront/storefront.types';

const storefrontSlice = createSlice({
    extraReducers: (builder) => {
        builder.addCase(fetchStorefrontItems.pending, (slice, { meta }) => {
            slice.loading = union(slice.loading, [meta.arg]);
        });
        builder.addCase(fetchStorefrontItems.fulfilled, (slice, { meta, payload }) => {
            slice.loading = difference(slice.loading, [meta.arg]);
            slice.loaded[meta.arg] = Date.now();
            slice.items = [...new Set(payload.items.map(({ itemId }) => itemId))];

            const seller = payload.sellers[0];
            if (seller) {
                slice.logoId = seller.logoId;
                slice.agentName = seller.agentName;
            }
        });
        builder.addCase(fetchStorefrontItems.rejected, (slice, { meta }) => {
            slice.loading = difference(slice.loading, [meta.arg]);
        });
    },
    initialState: defaultStorefrontSlice,
    name: 'storefront',
    reducers: {},
});

export const { reducer: storefrontReducer } = storefrontSlice;
